import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[aipbHoverHighlight]',
  standalone: true
})
export class HoverHighlightDirective {
  @Input() highlightColor = 'rgba(0,0,0,.06)';

  @Input() transitionDuration = '0.3s';

  private readonly previousBackgroundColor = 'white';

  constructor(private el: ElementRef) {
    this.previousBackgroundColor = this.el.nativeElement.style.backgroundColor;
    this.el.nativeElement.style.transitionDuration = this.transitionDuration;
  }

  @HostListener('mouseenter') onMouseEnter() {
    this.changeBackgroundColor(this.highlightColor);
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.changeBackgroundColor(this.previousBackgroundColor);
  }

  private changeBackgroundColor(color: string): void {
    this.el.nativeElement.style.backgroundColor = color;
  }
}
